export default "__VITE_ASSET__BWR2f8GR__"